import { render, staticRenderFns } from "./UpdateList.vue?vue&type=template&id=014a6a46"
import script from "./UpdateList.vue?vue&type=script&lang=js"
export * from "./UpdateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports